import { type RecordId } from '../types';
import { commonSerializedKeys, type FieldType } from '.';
import { type KeyPath } from '../collaboration/DataStoreRecordBehaviors';
import ItemCollection from '../models/ItemCollection';
import BaseField from './BaseField';
import SelectOption, { type SelectOptionData } from './SelectOption';

class SelectField extends BaseField<RecordId> {
  type: FieldType = 'SelectField';

  tags: boolean;
  editable: boolean;

  options: ItemCollection<SelectOption>;

  serializedKeys = [...commonSerializedKeys, 'optionsData', 'tags', 'editable'];

  // no-unused-vars disabled to allow omission of `controller` from `super` call
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor({ controller, ...data }) {
    super({
      tags: false,
      editable: true,
      ...data,
    });

    // Load options
    this.options = new ItemCollection(this, 'options', SelectOption);
  }

  addOption(values: Partial<Omit<SelectOptionData, 'id'>> = {}) {
    return this.options.add(values);
  }

  setFromRemote(key: KeyPath, value: any): void {
    super.setFromRemote(key, value);

    this.options.handleSetFromRemote(key, value);
  }

  get optionArray() {
    return Object.values(this.options);
  }
}

export default SelectField;
